import { getImageUrl } from '@chewy/chat-library-common';
import styles from './ProductImage.module.scss';

interface ProductImageProps {
    imageUrl: string;
    quantity?: number;
    name?: string;
}

export default function ProductImage({ imageUrl, quantity, name }: ProductImageProps) {

    return (
        <div className={styles.imageWrapper}>
            {imageUrl ? (<img
                src={getImageUrl(imageUrl, 50, true)}
                alt={name}
                className={styles.productImage}
            />) : (
                <div className={styles.productImagePlaceholder} aria-label={name} />
            )}
            {quantity && quantity > 1 && (
                <span className={styles.quantityBadge}>{quantity}</span>
            )}
        </div>
    );
}

